
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-qatar",
      function () {
        return require("private-next-pages/about-qatar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-qatar"])
      });
    }
  